import React, { Component } from 'react';
import { Cascader, Col, DatePicker, Form, Icon, Input, message, Modal, Row, Select } from 'antd';
import moment from 'moment';
import {
  queryMaterialDatabaseList,
  queryMaterialDatabaseType,
  queryMaterialDirectoryList,
} from '@api/administrative/material';
import { queryDeleteAttachment, queryFilePreview } from '@api/pub/attachment';
import CompanySearch from '@comm/companySearch';
import UploadFile from '@comm/upload/UploadFileTable';

const FormItem = Form.Item;

class ModalAccount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      returnEffect: [],
    };
  }

  componentDidMount() {
    const { effect } = this.props;
    const { returnEffect } = this.state;
    effect &&
      effect.map(item => {
        item.delFiles = [];
        returnEffect.push(item);
        return 1;
      });
    this.setState({ returnEffect });
    this.getDatabaseList();
  }

  componentWillReceiveProps(nextProps) {
    const { effect } = nextProps;
    const { returnEffect } = this.state;
    if (effect.length !== this.props.effect.length) {
      effect &&
        effect.map(item => {
          item.delFiles = [];
          returnEffect.push(item);
          return 1;
        });
      this.setState({ returnEffect });
    }
  }

  // 资料库列表
  getDatabaseList = () => {
    queryMaterialDatabaseList().then(res => {
      if (res.statusCode === 200) {
        this.setState({
          databaseList: res.data || [],
        });
      } else {
        message.error(res.message, 2.5);
      }
    });
  };

  handleDatabaseChange = (item, value) => {
    item.databaseUuid = value;
    this.getDirectoryList(item.databaseUuid);
    this.getDatabaseType(item.databaseUuid);
    this.props.form.resetFields([`directoryUuid${item.uuid}`, `materialType${item.uuid}`]);
  };

  // 资料目录列表
  getDirectoryList = uuid => {
    const { returnEffect } = this.state;
    queryMaterialDirectoryList({
      databaseUuid: uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        returnEffect.map(item => {
          if (item.databaseUuid === uuid) {
            this.formatList(res.data);
            item.directoryList = res.data;
          }
          return item;
        });
        this.setState({ returnEffect });
      } else {
        message.error(res.message, 2.5);
      }
    });
  };

  // 获取资料类型
  getDatabaseType = uuid => {
    const { returnEffect } = this.state;
    queryMaterialDatabaseType({
      databaseUuid: uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        returnEffect.map(item => {
          if (item.databaseUuid === uuid) {
            item.types = res.data;
          }
          return item;
        });
        this.setState({ returnEffect });
      } else {
        message.error(res.message, 2.5);
      }
    });
  };

  formatList = arr => {
    arr.map(item => {
      item.label = item.name;
      item.value = item.uuid;
      item.children && this.formatList(item.children);
      return item;
    });
  };

  handleOk = () => {
    const { returnEffect, databaseList } = this.state;
    const params = [];
    this.props.form.validateFields((err, values) => {
      if (!err) {
        returnEffect.map(item => {
          const it = { ...item };
          if (it.isReturn) {
            it.no = values[`no${item.uuid}`];
            it.databaseUuid = values[`databaseUuid${item.uuid}`];
            databaseList.map(i => {
              if (i.uuid === it.databaseUuid) {
                it.databaseName = i.name;
              }
              return i;
            });
            it.directoryUuid = item.directoryUuid;
            it.directory = item.directory;
            it.materialType = values[`materialType${item.uuid}`];
            it.returnDate = values[`returnDate${item.uuid}`].format('YYYY-MM-DD');
            it.companyUuid = values[`companyUuid${item.id}`];
            it.company = values[`company${item.id}`];
          }
          it.scans = values[`scans${item.uuid}`];
          if (it.delFiles.length > 0) {
            it.delFiles.map(i => {
              queryDeleteAttachment({
                uuid: i.uuid || i.uid,
              }).then(() => {});
              return i;
            });
          }
          params.push(it);
          return item;
        });
        this.props.handleOk(params);
      }
    });
  };

  onChange = (uuid, value, selectedOptions) => {
    const { returnEffect } = this.state;
    returnEffect.map(item => {
      if (item.uuid === uuid) {
        item.directoryUuid = selectedOptions[selectedOptions.length - 1].uuid;
        item.directory = selectedOptions[selectedOptions.length - 1].name;
      }
      return item;
    });
    this.setState({ returnEffect });
  };

  showLable = label => {
    const text = label[label.length - 1];
    return text;
  };

  handleCompanyChange = (id, value, option) => {
    this.props.form.setFieldsValue({
      [`company${id}`]: option ? option.props.children : '',
    });
  };

  /**
   *文件删除
   */
  fileRemove = (item, file) => {
    item.delFiles.push(file);
  };

  effectItem = item => {
    const { getFieldDecorator } = this.props.form;
    getFieldDecorator(`company${item.id}`);
    return (
      <div>
        <Row>
          <Col span={2} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
            <FormItem>
              {item.files.map(it => {
                return (
                  <div key={it.url}>
                    <a onClick={() => queryFilePreview(it)}>{it.name}</a>
                  </div>
                );
              })}
            </FormItem>
          </Col>
          <Col span={2} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
            {item.isReturn ? (
              <FormItem style={{ margin: 0, height: '60px' }}>
                {getFieldDecorator(`no${item.uuid}`)(<Input placeholder="请填写文件编号" />)}
              </FormItem>
            ) : null}
          </Col>
          <Col span={3} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
            {item.isReturn ? (
              <FormItem style={{ margin: 0, height: '60px' }}>
                {getFieldDecorator(`databaseUuid${item.uuid}`, {
                  rules: [{ required: true, message: '请填写资料库' }],
                })(
                  <Select
                    onChange={value => this.handleDatabaseChange(item, value)}
                    style={{ width: '100%' }}
                    placeholder="资料库选择"
                  >
                    {this.state.databaseList &&
                      this.state.databaseList.map(it => {
                        return (
                          <Select.Option value={it.uuid} key={it.uuid}>
                            {it.name}
                          </Select.Option>
                        );
                      })}
                  </Select>,
                )}
              </FormItem>
            ) : null}
          </Col>
          <Col span={3} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
            {item.isReturn ? (
              <FormItem style={{ margin: 0, height: '60px' }}>
                {getFieldDecorator(`companyUuid${item.id}`, {
                  rules: [{ required: true, message: '请选择用章公司' }],
                  initialValue: item.companyUuid,
                })(
                  <CompanySearch
                    companyName={item.company}
                    companyUuid={item.companyUuid}
                    onChange={(value, option) => this.handleCompanyChange(item.id, value, option)}
                    {...this.props}
                  />,
                )}
              </FormItem>
            ) : null}
          </Col>

          <Col span={3} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
            {item.isReturn ? (
              <FormItem style={{ margin: 0, height: '60px' }}>
                {getFieldDecorator(`directoryUuid${item.uuid}`, {
                  rules: [{ required: true, message: '请选择所属目录' }],
                })(
                  <Cascader
                    changeOnSelect
                    onChange={(value, selectedOptions) =>
                      this.onChange(item.uuid, value, selectedOptions)
                    }
                    options={item.directoryList}
                    placeholder="请选择所属目录"
                    displayRender={this.showLable}
                  />,
                )}
              </FormItem>
            ) : null}
          </Col>
          <Col span={2} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
            {item.isReturn ? (
              <FormItem style={{ margin: 0, height: '60px' }}>
                {getFieldDecorator(`materialType${item.uuid}`, {
                  rules: [{ required: true, message: '请选择所属类型' }],
                })(
                  <Select style={{ width: '100%' }} placeholder="所属类型选择">
                    {item.types &&
                      item.types.map(it => {
                        return (
                          <Select.Option value={it.name} key={it.name}>
                            {it.name}
                          </Select.Option>
                        );
                      })}
                  </Select>,
                )}
              </FormItem>
            ) : null}
          </Col>
          <Col span={1} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
            {item.isReturn ? (
              <span style={{ height: '30px', lineHeight: '30px' }}>{item.returnCount}</span>
            ) : null}
          </Col>
          <Col span={2} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
            {item.isReturn ? (
              <span style={{ height: '30px', lineHeight: '30px' }}>
                {moment(item.returnExpectedDate).format('YYYY-MM-DD')}
              </span>
            ) : (
              <span style={{ height: '30px', lineHeight: '30px' }}>不需要归档</span>
            )}
          </Col>
          <Col span={3} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
            {item.isReturn ? (
              <FormItem style={{ margin: 0, height: '60px' }}>
                {getFieldDecorator(`returnDate${item.uuid}`, {
                  rules: [{ required: true, message: '请填写实际归档时间' }],
                })(<DatePicker />)}
              </FormItem>
            ) : null}
          </Col>
          <Col span={3} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
            <FormItem style={{ margin: 0, height: '60px', paddingTop: '4px' }}>
              {getFieldDecorator(`scans${item.uuid}`, {
                initialValue: item.scans,
              })(
                <UploadFile
                  type="ghost"
                  fileList={item.scans}
                  style={{ width: '60%' }}
                  onRemove={file => this.fileRemove(item, file)}
                  isPreview
                />,
              )}
            </FormItem>
          </Col>
        </Row>
      </div>
    );
  };

  emptyInfo = () => {
    const _this = this;
    Modal.confirm({
      icon: <Icon type="login" />,
      title: '没有需要归档的文件,点击确定直接通过',
      onOk() {
        _this.handleOk();
      },
      onCancel() {
        _this.props.handleCancel(false);
      },
    });
  };

  render() {
    const { visible, handleCancel, confirmLoading } = this.props;
    const { returnEffect } = this.state;
    if (returnEffect.length) {
      return (
        <Modal
          title="行政文件归档"
          visible={visible}
          onOk={this.handleOk}
          okText="通过"
          confirmLoading={confirmLoading}
          onCancel={() => handleCancel(false)}
          width="95%"
        >
          <Row>
            <Col span={2} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
              附件(用章后)
            </Col>
            <Col span={2} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
              文件编号
            </Col>
            <Col span={3} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
              *归属资料库
            </Col>
            <Col span={3} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
              *归属公司
            </Col>
            <Col span={3} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
              *归属目录
            </Col>
            <Col span={2} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
              *归属类型
            </Col>
            <Col span={1} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
              归档数量
            </Col>
            <Col span={2} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
              预计归档时间
            </Col>
            <Col span={3} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
              *实际归档时间
            </Col>
            <Col span={3} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
              上传扫描件
            </Col>
          </Row>
          <Form>
            {returnEffect.map(item => {
              return this.effectItem(item);
            })}
          </Form>
        </Modal>
      );
    }
    return <div>{visible ? this.emptyInfo() : null}</div>;
  }
}

export default Form.create()(ModalAccount);



// WEBPACK FOOTER //
// ./src/components/comm/workflow/seal/ModalArchiveUpload.js